import styled from "styled-components";

export const StyledSection6 = styled.div`
  .section6-container {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
    padding-top: 32px;
    .line {
      display: block;
      margin: 20px 0;
      width: 100%;
      height: 1px;
      background: #dfdfdf;
      position: relative;
      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        padding: 0 20px;
        font-size: 12px;
        color: #cfcfcf;
      }
    }
  }
`;
